export default "__VITE_ASSET__CbI7KZpP__";